
    import { defineComponent, watch } from 'vue';
    import { useProgressCircularLoader } from '@/util/progress-circular-loader';

    export default defineComponent({
        data() {
            return {
                isLoading: false,
            };
        },
        methods: {
            syncProgress() {
                const { isOpen } = useProgressCircularLoader();
                this.isLoading = isOpen.value;

                watch(isOpen, (newVal) => {
                    this.isLoading = newVal;
                });                
            },

            //updateSnackBarModelValue(value) {
            //    this.snackBar = value;
            //    if (!value) {
            //        this.$snackbar.close();
            //    }
            //},

            //closeProgressCircularBar() {
            //    this.$snackbar.close();
            //},
        },
        created() {
            this.syncProgress();
        }
    });
